

















































































































































































































































import Vue from "vue";
import * as store from "../plugins/store";
import Component from "vue-class-component";
import {i18n} from "../plugins/i18n";
import Doughnut_summary from "../components/Doughnut_summary.vue";
import {Watch} from "vue-property-decorator";

Vue.component("Doughnut_summary", Doughnut_summary);

@Component
export default class Home extends Vue {
    windowSummary: number = 0;
    length = 2;
    n = 0;

    get isMobile() {
        return window.innerWidth < 600;
    }

    get imgNum() {
        let num = Math.floor(Math.random() * Math.floor(7));  // 0-6
        return "1-" + num + ".webp"
    }

    fixParallax(offset: number): void {
        let parallax = document.getElementById("parallax1") as HTMLElement;
        let parallaxChild = parallax.firstChild as HTMLElement;
        let image = parallaxChild.firstChild as HTMLImageElement;
        let changes = offset + "px;";
        image.setAttribute("style", "top: " + changes);
    }

    mounted(): void {
        let imgHeight = 1280;
        let height = 500;
        let percentScrolled = window.innerHeight / (height + window.innerHeight);
        let parallaxDist = imgHeight - height;
        let offset = -1.1 * Math.round(parallaxDist * percentScrolled);
        console.log(percentScrolled);
        console.log(offset);
        this.fixParallax(offset);
    }

    Doughnut_summaryRussiaData: object = {
        labels: ['Gaz naturel',
            'Pétrole',
            'Charbon',
            'Nucléaire',
            'Hydroénergie',
            'Bioénergie',
            'Renouvelables'],
        data: [338334, 153963, 113581, 53279, 15908, 7801, 165]
    };
    Doughnut_summaryCanadaData: object = {
        labels: ['Gaz naturel',
            'Pétrole',
            'Charbon',
            'Nucléaire',
            'Hydroénergie',
            'Bioénergie',
            'Renouvelables'],
        data: [100864, 99921, 17016, 26346, 33752, 13686, 2826]
    };

}
